import { render, staticRenderFns } from "./PickupsToday.vue?vue&type=template&id=20f612d2&scoped=true&"
import script from "./PickupsToday.vue?vue&type=script&lang=js&"
export * from "./PickupsToday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f612d2",
  null
  
)

export default component.exports